module.exports = __webpack_public_path__ + "media/dove.5f6d0491.webm";